import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Redirect({ to, useNativeNavigation = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === to) {
      return;
    }
    if (useNativeNavigation) {
      window.location.assign(to);
    } else {
      navigate(to);
    }
  }, [location, navigate, to, useNativeNavigation]);

  return null;
}
